import { router } from '@inertiajs/react'
import { Badge } from '@/components/ui/Badge'
import { Button } from '@/components/ui/Button'

// Header widget on the request page: how many comments so far, the way to
// the task form, and Discard. Mirrors RevisionSubmitWidget's shape.
export default function RevisionRequestWidget({ count, formHref, onDiscard, sendDisabled = false }: { count: number; formHref: string; onDiscard: () => void; sendDisabled?: boolean }) {
  return (
    <div className="flex min-w-0 flex-col gap-0.5 rounded-lg border px-3 py-1.5" style={{ background: 'var(--background)', borderColor: 'var(--border)' }}>
      <div className="flex items-center gap-2">
        <Badge variant="info" className="px-1.5 py-0 text-[10px] whitespace-nowrap">Request</Badge>
        <span className="whitespace-nowrap text-xs font-medium text-foreground">
          {count === 0 ? 'No comments yet' : `${count} ${count === 1 ? 'comment' : 'comments'}`}
        </span>
      </div>
      <div className="flex items-center gap-2 text-[11px] text-muted-foreground">
        {count > 0 && (
          <Button size="sm" variant="ghost" className="h-5 px-2 text-[11px] text-muted-foreground" onClick={onDiscard}>Discard</Button>
        )}
        <Button size="sm" className="ml-auto h-5 px-2 text-[11px]" disabled={count === 0 || sendDisabled} onClick={() => router.visit(formHref)}>
          Request revision
        </Button>
      </div>
    </div>
  )
}
